import { PageHeader } from "@/components/PageHeader";
import { ButtonLink } from "@/components/ui";
import { useAuth } from "@/auth/AuthProvider";

export default function Forbidden() {
  const { user } = useAuth();
  return (
    <div className="container container--narrow">
      <PageHeader
        eyebrow="403"
        title="You don't have access"
        description={
          user
            ? `Signed in as ${user.email}, but this page needs a permission your account doesn't hold.`
            : "This page requires additional permissions."
        }
      />
      <div className="row">
        <ButtonLink to="/" variant="primary">
          Back home
        </ButtonLink>
        <ButtonLink to="/dashboard" variant="secondary">
          Your dashboard
        </ButtonLink>
      </div>
    </div>
  );
}
